import EA from 'helpers/init';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default EA.Methods.headerChange = ($this) => {
    const parent = $this.querySelector('.sticky-wrap');
    const sticky = document.querySelector('.sticky-content');
    const bodyCustomClass = document.body;

    gsap.to(sticky, {
        scrollTrigger: {
            trigger: parent,
            start: 'bottom 5%',
            end: 'top bottom',
            onEnter: () => {
                stickyActive();
            },
            onEnterBack: () => {
                stickyNotActive();
            },
            onLeave: () => {
                stickyNotActive();
            },
            onLeaveBack: () => {
                stickyActive();
            },
        },
    });

    bodyCustomClass.classList.add('header-change');

    function stickyActive() {
        sticky.classList.add('active');
        document.body.classList.remove('header-sticky');
    }
    
    function stickyNotActive() {
        sticky.classList.remove('active');
        document.body.classList.add('header-sticky');
    }

    window.addEventListener('resize', () => {
        ScrollTrigger.refresh();
    });

};